var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "M36.32 60.5V44.8a3 3 0 013-3h16.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M33.9 60.91a6.98 6.98 0 004.95-2.01c3.68-3.66 11.39-11.29 15.09-14.95A6.97 6.97 0 0056 39V18.53a4.44 4.44 0 00-4.45-4.44H23.44A4.45 4.45 0 0019 18.53v37.89a4.45 4.45 0 004.43 4.44l10.49.05zm-5.72-36.98h18.17m-18.17 6.02h11.15M28.18 36.2h19.16m-19.16 6.4h2.34m-2.34 6.22h2.34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.b321de348a357bc81e219b32a56a0fe7.svg";
export { ForwardRef as ReactComponent };